module.exports = __webpack_public_path__ + "static/media/confused-john-travolta.ed323192.gif";